import { getContents } from "@/services/api";
import { CONTENT_TYPES } from "@/utils/content";
import { useEffect, useState } from "react";
import { useDebounce } from "use-debounce";
import useGetContentTypeUuid from "./useGetContentUuid";
import { getSpecialReport } from "@/services/api/QuotaMeter";

function useGetReports({ onErrorCallback }) {
  const reportType = useGetContentTypeUuid(CONTENT_TYPES.SPECIAL_REPORTS);
  const [search, setSearch] = useState("");
  const [topic, setTopic] = useState();
  const [reports, setReports] = useState([]);
  const [quota, setQuota] = useState({
    used: 0,
    total: 2,
    remaining: 2,
    hasSubscription: false,
    items: [],
    downloadUnlimited: false,
    downloadUsed: 0,
    downloadTotal: 2,
    downloadRemaining: 2,
    downloadedUuids: [],
    isLoaded: false,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setLoading] = useState(false);
  const [searchQuery] = useDebounce(search, 500);

  const fetchQuota = async () => {
    try {
      const response = await getSpecialReport();
      const data = response.data;
      setQuota({
        used: data.used_quota,
        total: data.total_quota,
        remaining: data.remaining_quota,
        hasSubscription: data.has_active_subscription,
        items: data.items,
        downloadUnlimited: !!data.download_unlimited,
        downloadUsed: data.download_used_quota ?? 0,
        downloadTotal: data.download_total_quota ?? 2,
        downloadRemaining: data.download_remaining_quota ?? 0,
        downloadedUuids: data.downloaded_uuids || [],
        isLoaded: true,
      });
    } catch (error) {
      console.error('Error fetching quota:', error);
    }
  };

  const fetchReports = async function (page) {
    if (!reportType) return null;

    try {
      setLoading(true);

      let filter = {};
      if (searchQuery) {
        filter["search"] = searchQuery;
      }
      if (topic) {
        filter["topicUuid"] = topic;
      }
      filter["contentTypeUuid"] = reportType.uuid;

      const response = await getContents(filter);
      const result = response.data;
      const page = result ? result.meta.current_page : 1;

      if (page == 1) {
        setReports(result.data || []);
      } else {
        let currentRepots = [...reports];
        setReports(currentRepots.concat(result.data || []));
      }

      if (page > 0) {
        setCurrentPage(page);
      }
    } catch (error) {
      if (onErrorCallback) {
        onErrorCallback(error);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReports(1);
    fetchQuota();
  }, [searchQuery, topic, reportType]);

  return {
    search,
    setSearch,
    reports,
    currentPage,
    isLoading,
    topic,
    setTopic,
    fetchReports,
    quota,
    refetchQuota: fetchQuota
  };
}

export { useGetReports };
